<script setup>
import { reactive } from 'vue';
import { Physician } from '@/libraries/ClassDefinitions';
import { registerUserInformation } from '../firebase_files/user_functions'
import router from '@/router';

const state = reactive({
    physician: new Physician(),
});



const emits = defineEmits(['go-back']);

async function submitPhysician() {
    try{
        await registerUserInformation(state.physician);
        router.push({ name: 'home' });
    }catch(error){
        alert(`Oh no, Something went wrong! Please contact support@verusamb.com for 24/7 support.\nError: ${JSON.stringify(error)}`)
        console.log(JSON.stringify(error))
    }
}

function goBack(){
    emits('go-back');
}

</script>
<template>
    <div class="form-box">
        <h1 class="prompt-text">Welcome, Doctor!</h1>
        <h4 class="prompt-text">We are really excited for you to start using Verus!</h4>
        <h4 class="prompt-text">First, we need to know a little bit about you to get your account set up:</h4>

            <label class="registration-label">Full name:</label>
            <input v-model="state.physician.name">
            
            <label>CPSO#</label>
            <input v-model="state.physician.cpso">

            <label>Department</label>
            <select v-model="state.physician.department">
                <option value="departmentOfOncology">Department of Oncology</option>
            </select>

            <label>Hospital</label>
            <select v-model="state.physician.hospital">
                <option value="kingstonGeneralHospital">Kingston General Hospital</option>
                <option value="princessMargaretHospital">Princess Margaret Hospital</option>
            </select>

            <label>Specialization</label>
            <select v-model="state.physician.specialization">
                <option value="radiationOncology">Radiation Oncology</option>
            </select>
            

            <label>Email to submit billing report.</labeL>
            <input v-model="state.physician.billingAgent">
            <br>

            <button @click="goBack">Back</button>
            <button @click="submitPhysician" class="primary">Submit</button>
    </div>
</template>
<style scoped lang="scss">

button{
    // margin-top: 3rem;
    margin: 3rem 1rem 0rem 1rem;
}
.prompt-text{
    // display: none;
    justify-content: center;

}
.form-box{
    width:75%;
    text-align: center;
    background-color: #ffffff;
    // padding:50px;
    padding-top: 0.625rem;
    padding-bottom: 3.125rem;
    border-radius: 25px;
    // percentage used here for clarity
    // margin: 0% 12.5% 0% 12.5%; // this is being handled in partent view
    label{
        // flex: 1;
        
        // width: 100%;
        display: block;
        padding-top: 1rem;

    }
    input, select{
        width: 350px;
        text-align: center;

    }
}


// label{

// }
// input{
//     display: flex;
//     justify-content: center;
// }
</style>
